export default __webpack_public_path__ + "static/media/Icon=Stores.44ad0c00.svg";